var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsArray, IsDate, IsEnum, IsInt, IsNumber, IsObject, IsOptional, IsString, ValidateNested, } from "class-validator";
import { EmployeeStatus } from "../../model.types";
import { safeAssign } from "./safe-assign";
export var LicenseType;
(function (LicenseType) {
    LicenseType["aiAssistantLite"] = "aiAssistantLite";
    LicenseType["aiAssistantPro"] = "aiAssistantPro";
})(LicenseType || (LicenseType = {}));
export const LICENSE_TYPE_LABEL = {
    [LicenseType.aiAssistantLite]: "Yna Suite",
    [LicenseType.aiAssistantPro]: "Yna Pro",
};
export class SeatInfoDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsEnum(LicenseType),
    __metadata("design:type", String)
], SeatInfoDTO.prototype, "licenseType", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], SeatInfoDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], SeatInfoDTO.prototype, "employeeFirstName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], SeatInfoDTO.prototype, "employeeLastName", void 0);
__decorate([
    Expose(),
    IsEnum(EmployeeStatus),
    __metadata("design:type", String)
], SeatInfoDTO.prototype, "employeeStatus", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], SeatInfoDTO.prototype, "assignedAt", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], SeatInfoDTO.prototype, "validUntil", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], SeatInfoDTO.prototype, "validFrom", void 0);
export class GetLicenseSeatStateDTO {
}
export class LicenseSeatStateDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], LicenseSeatStateDTO.prototype, "bookedSeats", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], LicenseSeatStateDTO.prototype, "nextBillingCycle", void 0);
__decorate([
    Expose(),
    IsObject(),
    __metadata("design:type", Object)
], LicenseSeatStateDTO.prototype, "pricePerSeat", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => SeatInfoDTO),
    __metadata("design:type", Array)
], LicenseSeatStateDTO.prototype, "seats", void 0);
export var SeatChangeType;
(function (SeatChangeType) {
    SeatChangeType["AssignSeat"] = "assignSeat";
    SeatChangeType["CancelSeat"] = "cancelSeat";
})(SeatChangeType || (SeatChangeType = {}));
export class SeatChangeRequest {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsEnum(LicenseType),
    __metadata("design:type", String)
], SeatChangeRequest.prototype, "licenseType", void 0);
__decorate([
    Expose(),
    IsEnum(SeatChangeType),
    __metadata("design:type", String)
], SeatChangeRequest.prototype, "type", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], SeatChangeRequest.prototype, "employeeId", void 0);
export class UpdateLicenseSeatStateDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateLicenseSeatStateDTO.prototype, "bookedSeats", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => SeatChangeRequest),
    __metadata("design:type", Array)
], UpdateLicenseSeatStateDTO.prototype, "changes", void 0);
//# sourceMappingURL=seat.dto.js.map